import { usePageTitle } from "@/hooks/use-page-title";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Landing() {
  usePageTitle("Welcome");
  const handleLogin = () => {
    window.location.href = "/api/login";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <Card className="max-w-md w-full mx-4">
        <CardContent className="pt-6">
          <div className="text-center space-y-6">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">Don Norman Associates</h2>
              <p className="mt-2 text-sm text-gray-600">Authority Management System</p>
            </div>
            
            <div className="space-y-4">
              <p className="text-sm text-gray-600">
                Manage trucking compliance services, work orders, and carrier tracking with role-based access control.
              </p>
              
              <div className="space-y-3">
                <Button 
                  onClick={handleLogin}
                  className="w-full"
                  size="lg"
                >
                  Sign In with Replit
                </Button>
                
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <span className="w-full border-t" />
                  </div>
                  <div className="relative flex justify-center text-xs uppercase">
                    <span className="bg-white px-2 text-gray-500">
                      Or
                    </span>
                  </div>
                </div>
                
                <Button 
                  onClick={() => window.location.href = "/login"}
                  variant="outline"
                  className="w-full"
                  size="lg"
                >
                  Internal Employee Login
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
